export default __webpack_public_path__ + "static/media/product5.a56535a5.png";